import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  Button,
  Col,
  DatePicker,
  Drawer,
  Form,
  Input,
  Row,
  Space,
  message,
} from "antd";
import { AiOutlineClose } from "react-icons/ai";
import {
  handleDeleteContactDate,
  handleUpdateContactDate,
} from "../../../../api/contacts";
import { useEffect } from "react";
import Moment from "react-moment";

const { TextArea } = Input;

export default function DeleteDate({
  isVisible,
  setVisible,
  contact,
  selected,
}: any) {
  const [form] = Form.useForm();
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation({
    mutationFn: handleDeleteContactDate,
    onSuccess: () => {
      message.success("Deleted Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["contacts"] });
      setVisible(false);
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async () => {
    const values = await form.getFieldsValue();
    const data = {
      ...values,
    };
    await mutate({ data, _id: contact?._id, date_id: selected?._id });
  };

  const clearForm = () => {
    form.resetFields();
  };

  useEffect(() => {
    form.setFieldsValue({ date: selected?.date });
    form.setFieldsValue({ description: selected?.description });
    form.setFieldsValue({ note: selected?.note });
  }, [contact, selected]);

  return (
    <Drawer
      title={
        <div className="flex items-center">
          <span className="mr-2 text-lg">
            <span className="font-bold">DELETE : </span>
          </span>
          <div className="flex text-gray-500 px-2 uppercase">Date</div>
        </div>
      }
      placement={"right"}
      width={900}
      onClose={() => setVisible(!isVisible)}
      open={isVisible}
      closable={false}
      extra={
        <Space>
          <Button
            type="default"
            color="#E50000"
            onClick={() => setVisible(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <Form
        id="deleteContactDate"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <div className="">
          <div className="">
            Are you sure you want to{" "}
            <span className="text-red-600">Delete</span>
          </div>
          <div className="font-bold text-lg">
            Date :{" "}
            {selected?.date ? (
              <Moment format="Do MMM, YYYY">{selected?.date}</Moment>
            ) : (
              "-"
            )}
          </div>
          <div className="flex flex-col">
            <div className="">Description</div>
            <div className="">{selected?.description || ""}</div>
          </div>
          <div className="flex flex-col">
            <div className="">Note</div>
            <div className="">{selected?.note || ""}</div>
          </div>
        </div>

        <Form.Item>
          <Button danger type="primary" htmlType="submit" loading={isLoading}>
            Delete
          </Button>
          <Button
            danger
            htmlType="button"
            className="mx-2"
            onClick={() => setVisible(false)}
          >
            Cancel
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
}
